import { connect } from 'react-redux';
import Report from './Report';
import { compose } from 'recompose'
import { reportSelectors} from './redux'

const mapStateToProps = (state) => ({
  errorMessage: reportSelectors.errorMessage(state),
  isLoading: reportSelectors.isLoading(state),
});

export default compose(
  connect(mapStateToProps)
)(Report);